import { styled, useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import Grid from '@mui/material/Grid2'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Typography from '@mui/material/Typography'
import { useFormik } from 'formik'
import { useEffect } from 'react'
import { useSettingStore } from '../../../../store/storeSetting'
import { useWrapperStore } from '../../../../store/storeWrapper'
import { ModelsSetMode } from '../../../../swagger/dto'
import { theme } from '../../../../theme'

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
    justifyContent: 'space-between',
    textAlign: 'left',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    columnGap: '8px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
        gridTemplateColumns: '1fr 1fr',
    },
}))

const notificationDone = 'Выбор модели успешно сохранен'

export const AiSetupForm = ({ initialValues }) => {
    const { setStateNotification } = useWrapperStore((state) => state)
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const {
        updateUserAi,
        isLoadingUpdateUserAi,
        errorUpdateUserAi,
        isDoneUpdateUserAi,
        setIsDoneUpdateUserAi,
    } = useSettingStore((state) => state)

    useEffect(() => {
        if (isDoneUpdateUserAi) {
            setStateNotification({ isOpen: true, text: notificationDone, isError: false })
            setIsDoneUpdateUserAi(false)
        }
    }, [isDoneUpdateUserAi])

    useEffect(() => {
        if (errorUpdateUserAi) {
            setStateNotification({ isOpen: true, text: errorUpdateUserAi, isError: true })
        }
    }, [errorUpdateUserAi])

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: async (values) => {
            const { mode } = values
            await updateUserAi({ model_set_mode: mode })
        },
    })

    return (
        <>
            <Grid sx={{ padding: '16px' }}>
                <form onSubmit={formik.handleSubmit}>
                    <Typography variant="h4" sx={{ color: '#121317', mb: '4px' }}>
                        Выбор модели
                    </Typography>
                    <Typography variant="caption2" component="p">
                        Настройка определяет, какая модель будет выбрана при формировании запроса
                    </Typography>

                    <FormControl sx={{ my: '24px' }}>
                        <StyledRadioGroup
                            value={formik.values.mode}
                            onChange={formik.handleChange}
                            id="mode"
                            name="mode">
                            <Box
                                sx={{
                                    borderRadius: '12px',
                                    border: '1px solid #F4F4F6',
                                    padding: '0px 12px 12px',
                                }}>
                                <FormControlLabel
                                    sx={{
                                        m: 0,
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                    labelPlacement="start"
                                    value={ModelsSetMode.OPTIMAL}
                                    control={<Radio />}
                                    label={
                                        <>
                                            <Box sx={{ display: 'flex' }}>
                                                <Typography
                                                    variant="caption1"
                                                    component="p"
                                                    sx={{
                                                        color: '#181B25',
                                                    }}>
                                                    Оптимальная
                                                </Typography>
                                            </Box>
                                        </>
                                    }
                                />
                                <Typography variant="caption2" component="p" sx={{ width: '90%' }}>
                                    Оптимальный режим, качество результата ≥ 70%
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    borderRadius: '12px',
                                    border: '1px solid #F4F4F6',
                                    padding: '0px 12px 12px',
                                }}>
                                <FormControlLabel
                                    sx={{
                                        m: 0,
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                    labelPlacement="start"
                                    value={ModelsSetMode.BEST}
                                    control={<Radio />}
                                    label={
                                        <Typography
                                            variant="caption1"
                                            component="p"
                                            sx={{
                                                color: '#181B25',
                                            }}>
                                            Лучшая
                                        </Typography>
                                    }
                                />
                                <Typography variant="caption2" component="p">
                                    Максимально доступное качество результата
                                </Typography>
                            </Box>
                        </StyledRadioGroup>
                    </FormControl>

                    <Button
                        fullWidth={isMobile}
                        type="submit"
                        disabled={isLoadingUpdateUserAi}
                        variant="contained">
                        Сохранить
                    </Button>
                </form>
            </Grid>
        </>
    )
}
